import { Navigate, Outlet, useOutletContext, useParams } from 'react-router-dom'

import { Text } from '@factorialco/deprecated-design-system'
import { EmployeeMyTrainingsIndexPageDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { SessionDetail } from 'modules/trainings/components/MyTrainings/SessionDetail'
import { useMyTrainingDatatable } from 'modules/trainings/hooks/MyTrainings/useMyTrainingDatatable'

const SessionModalWrapper = () => {
  const { sessionId } = useParams()
  const { findTrainingBySessionId } = useMyTrainingDatatable()
  const trainingId = findTrainingBySessionId(String(sessionId))?.id

  if (trainingId === undefined) {
    return <></>
  }

  return <SessionModal trainingId={trainingId} />
}

interface Props {
  trainingId: string
}
const SessionModal = ({ trainingId }: Props) => {
  const { sessionId } = useParams()
  const { navigation } = useNavigation()
  const { employeeId, employeeAccessId } = useOutletContext<{
    employeeId: string
    employeeAccessId: string
  }>()
  const { loading, data: employeeMyTrainingsData } = useQuery(
    EmployeeMyTrainingsIndexPageDocument,
    {
      variables: { id: trainingId },
    }
  )
  const training = employeeMyTrainingsData?.trainings.trainingsConnection.nodes.at(0)

  if (loading || !training) {
    return <></>
  }

  const session = training.sessions.find((s) => s.id === String(sessionId))

  if (!training || !session)
    return (
      <Navigate
        replace
        to={navigation.employees.id.training.fullPath({ id: String(employeeId) })}
      />
    )

  return (
    <>
      <Outlet context={{ employeeId, employeeAccessId, session }} />
      <SessionDetail
        title={
          <Text.Normal weight="semibold" size="300">
            {i18n.t('trainings.my_training.next_session.next_session_detail')}
          </Text.Normal>
        }
        to={navigation.employees.id.training.fullPath({ id: String(employeeId) })}
        training={training}
        session={session}
        certificatesModalPath={navigation.employees.id.training.nextSession.certificates.upload.fullPath(
          {
            id: String(employeeId),
            sessionId: String(sessionId),
          }
        )}
      />
    </>
  )
}

export default SessionModalWrapper
